export default __webpack_public_path__ + "static/media/cp_geo_ve.42c44704.svg";